// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l67o","toggleWrap":"styles_toggleWrap__2rvYn","content":"styles_content__YA_d7","selectAreaCode":"styles_selectAreaCode__2p30B"};